import React, { useEffect, useState, Children, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Check, Calendar, Clock, MapPin, AlertTriangle, X, CheckCircle } from 'lucide-react';
export function SalesPage() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [notifications, setNotifications] = useState<Array<{
    id: number;
    name: string;
    location: string;
    time: string;
  }>>([]);
  useEffect(() => {
    // Load Wistia player script (shared)
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    // Load individual video embed scripts
    const video1Script = document.createElement('script');
    video1Script.src = 'https://fast.wistia.com/embed/zadn492ltd.js';
    video1Script.async = true;
    video1Script.type = 'module';
    document.body.appendChild(video1Script);
    const video2Script = document.createElement('script');
    video2Script.src = 'https://fast.wistia.com/embed/n6ngvv6hee.js';
    video2Script.async = true;
    video2Script.type = 'module';
    document.body.appendChild(video2Script);
    const video3Script = document.createElement('script');
    video3Script.src = 'https://fast.wistia.com/embed/psa74yg6wr.js';
    video3Script.async = true;
    video3Script.type = 'module';
    document.body.appendChild(video3Script);
    const video4Script = document.createElement('script');
    video4Script.src = 'https://fast.wistia.com/embed/4d7zhpdcnk.js';
    video4Script.async = true;
    video4Script.type = 'module';
    document.body.appendChild(video4Script);
    const video5Script = document.createElement('script');
    video5Script.src = 'https://fast.wistia.com/embed/9yq00dgg3u.js';
    video5Script.async = true;
    video5Script.type = 'module';
    document.body.appendChild(video5Script);
    return () => {
      document.body.removeChild(playerScript);
      document.body.removeChild(video1Script);
      document.body.removeChild(video2Script);
      document.body.removeChild(video3Script);
      document.body.removeChild(video4Script);
      document.body.removeChild(video5Script);
    };
  }, []);
  // Registration notifications
  useEffect(() => {
    const names = ['María González', 'Carlos Rodríguez', 'Ana Martínez', 'Luis Fernández', 'Carmen López', 'Jorge Sánchez', 'Patricia Ramírez', 'Roberto Torres'];
    const cities = [{
      city: 'Houston',
      country: 'USA'
    }, {
      city: 'Caracas',
      country: 'Venezuela'
    }, {
      city: 'Bogotá',
      country: 'Colombia'
    }, {
      city: 'Guadalajara',
      country: 'México'
    }, {
      city: 'Valencia',
      country: 'Venezuela'
    }, {
      city: 'Cali',
      country: 'Colombia'
    }];
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = cities[Math.floor(Math.random() * cities.length)];
      const minutesAgo = Math.floor(Math.random() * 30) + 1;
      const timeText = minutesAgo === 1 ? 'hace 1 minuto' : `hace ${minutesAgo} minutos`;
      const newNotification = {
        id: Date.now(),
        name: randomName,
        location: `${randomLocation.city}, ${randomLocation.country}`,
        time: timeText
      };
      setNotifications(prev => [...prev, newNotification]);
      setTimeout(() => {
        setNotifications(prev => prev.filter(n => n.id !== newNotification.id));
      }, 5000);
    };
    const firstTimeout = setTimeout(showNotification, 3000);
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, []);
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  return <div className="min-h-screen bg-white text-slate-800 font-sans selection:bg-orange-500/30" data-id="element-21">
      <style data-id="element-22">{`
        wistia-player[media-id='zadn492ltd']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zadn492ltd/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 193.61%;
        }
        wistia-player[media-id='n6ngvv6hee']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/n6ngvv6hee/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
        wistia-player[media-id='psa74yg6wr']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/psa74yg6wr/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
        wistia-player[media-id='4d7zhpdcnk']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/4d7zhpdcnk/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 173.33%;
        }
        wistia-player[media-id='9yq00dgg3u']:not(:defined) {
          background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/9yq00dgg3u/swatch');
          display: block;
          filter: blur(5px);
          padding-top: 177.78%;
        }
      `}</style>

      {/* Registration Notifications */}
      <div className="fixed bottom-6 left-6 z-50 space-y-3" data-id="element-23">
        <AnimatePresence data-id="element-24">
          {notifications.map(notification => <motion.div key={notification.id} initial={{
          opacity: 0,
          x: -100,
          scale: 0.9
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          x: -100,
          scale: 0.9
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} className="bg-white rounded-xl shadow-2xl border border-green-100 p-4 max-w-sm backdrop-blur-sm" data-id="element-25">
              <div className="flex items-start gap-3" data-id="element-26">
                <div className="flex-shrink-0 mt-0.5" data-id="element-27">
                  <CheckCircle className="w-5 h-5 text-green-500" data-id="element-28" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-29">
                  <p className="font-semibold text-slate-900 text-sm truncate" data-id="element-30">
                    {notification.name}
                  </p>
                  <p className="text-slate-500 text-xs mt-0.5" data-id="element-31">
                    {notification.location}
                  </p>
                  <p className="text-slate-600 text-xs mt-1.5" data-id="element-32">
                    Se registró al entrenamiento
                  </p>
                  <p className="text-slate-400 text-xs mt-1" data-id="element-33">
                    {notification.time}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </AnimatePresence>
      </div>

      {/* 1. Hero Section */}
      <section className="relative px-6 pt-24 pb-20 md:pt-32 md:pb-28 overflow-hidden" data-id="element-34">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-orange-100/30 rounded-full blur-3xl -z-10" data-id="element-35" />

        <div className="max-w-4xl mx-auto text-center" data-id="element-36">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-37">
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-10 leading-tight" style={{
            color: '#FA7315'
          }} data-id="element-38">
              Tu negocio factura… <br className="hidden md:block" data-id="element-39" />
              <span className="text-slate-600" data-id="element-40">
                Pero algo no termina de encajar
              </span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed mb-10" data-id="element-41">
              <p data-id="element-42">
                No es que no tengas talento. Es un techo invisible creado por
                fugas de tiempo, energía y foco que hoy están decidiendo por ti.
                El problema no es que te falte tiempo,
              </p>
              <p className="font-bold text-slate-900 text-xl md:text-2xl border-l-4 md:border-l-0 md:border-b-4 border-orange-500 pl-6 md:pl-0 md:pb-3 text-left md:text-center md:inline-block" data-id="element-43">
                es que estas invirtiendo horas que no te devuelven nada
              </p>
              <p data-id="element-44">
                Y sin darte cuenta te está haciendo perder mucho mas que dinero
              </p>
            </div>

            <div className="mb-10" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/fo1Ka4yvFFYCoXNX5Rx4gT/Hero.jpg" alt="Juega Desde Otro Nivel - Entrenamiento" className="w-full rounded-2xl shadow-xl" data-id="element-46" />
            </div>

            <div className="p-8 bg-slate-50 rounded-2xl border border-slate-200 shadow-sm mb-6" data-id="element-47">
              <p className="text-base md:text-lg text-slate-700 leading-relaxed" data-id="element-48">
                En 90 minutos Identifica qué horas te hacen perder mercado
                (fugas críticas), qué actividades mueven resultados y cómo crear
                sistemas diarios que se reflejen en tu billetera.
              </p>
            </div>

            <p className="text-base md:text-lg font-semibold text-slate-700" data-id="element-49">
              Sin motivación, sin discurso y sin perder tiempo.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 2. Problem Checkmarks */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-50">
        <div className="max-w-3xl mx-auto" data-id="element-51">
          <motion.ul className="space-y-5" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} data-id="element-52">
            {['Tu agenda está llena, pero tu impacto no crece al mismo ritmo', 'Tomas decisiones cansado (y eso cuesta clientes)', 'Todo avanza solo si tú empujas', 'Sientes que podrías dar más… pero algo te frena', 'Se te van seguimientos por urgencias y al final "se enfría" el cierre', 'Estás respondiendo mucho… pero cerrando menos de lo que podrías.', 'Sientes que otros avanzan porque son más rápidos con sistema, no porque sean mejores.'].map((item, index) => <motion.li key={index} variants={fadeInUp} className="flex items-start gap-4 text-slate-700 text-base md:text-lg" data-id="element-53">
                <span className="flex-shrink-0 mt-1.5 text-orange-500 text-xl" data-id="element-54">
                  ✔️
                </span>
                <span data-id="element-55">{item}</span>
              </motion.li>)}
          </motion.ul>

          <motion.div variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="mt-12 text-center" data-id="element-56">
            <p className="text-lg md:text-xl font-medium text-slate-900 mb-10" data-id="element-57">
              Si esto te suena, no es casualidad. Estás jugando por debajo de tu
              verdadero nivel.
            </p>

            <CTAButton text="Ajustar mi nivel de juego ahora" scrollTo="final-cta" className="w-full md:w-auto" data-id="element-58" />
          </motion.div>
        </div>
      </section>

      {/* 3. Training Details */}
      <section className="px-6 py-10 border-y border-slate-200 bg-white" data-id="element-59">
        <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-6 md:gap-16 text-sm md:text-base font-bold uppercase tracking-wider text-slate-600" data-id="element-60">
          <div className="flex items-center gap-3" data-id="element-61">
            <Clock className="w-5 h-5" style={{
            color: '#FA7315'
          }} data-id="element-62" />
            <span data-id="element-63">90 minutos</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-64">
            <span className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse" data-id="element-65" />
            <span data-id="element-66">Online</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-67">
            <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse" data-id="element-68" />
            <span data-id="element-69">En vivo</span>
          </div>
        </div>
        <p className="text-center mt-6 text-slate-500 text-sm md:text-base" data-id="element-70">
          Sales con claridad, foco y un sistema mínimo que se sostiene.
        </p>
      </section>

      {/* 4. Title Section */}
      <section className="px-6 py-24 text-center relative overflow-hidden bg-gradient-to-b from-white via-orange-50/20 to-white" data-id="element-71">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="relative z-10 max-w-4xl mx-auto" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-black mb-8" style={{
          color: '#FA7315'
        }} data-id="element-73">
            JUEGA DESDE OTRO NIVEL
          </h2>
          <p className="text-xl md:text-2xl text-slate-700 max-w-3xl mx-auto leading-relaxed" data-id="element-74">
            Entrenamiento práctico para vendedores y líderes que tienen
            resultados… y saben que aún no están en su verdadero nivel.
          </p>
        </motion.div>
      </section>

      {/* 5. Problem Deep Dive */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-75">
        <div className="max-w-4xl mx-auto space-y-16" data-id="element-76">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="space-y-8 text-lg text-slate-700" data-id="element-77">
            <p className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-78">
              El problema no es que hagas poco.
            </p>
            <p className="text-2xl md:text-3xl font-bold" style={{
            color: '#FA7315'
          }} data-id="element-79">
              El problema es todo lo que haces… y no debería existir.
            </p>

            <div className="pl-6 border-l-4 border-slate-300 space-y-5" data-id="element-80">
              <p data-id="element-81">
                Cada día tomas decisiones. Cada día sostienes responsabilidades.
                Cada día resuelves problemas que nadie más ve.
              </p>
              <p className="font-semibold" data-id="element-82">Y aun así:</p>
            </div>

            <ul className="space-y-3 font-semibold text-slate-900 pl-6" data-id="element-83">
              <li data-id="element-84">• Te falta aire.</li>
              <li data-id="element-85">• El día se te va.</li>
              <li data-id="element-86">• El equipo depende demasiado de ti.</li>
              <li data-id="element-87">• Sientes que corres… pero no avanzas como quieres.</li>
            </ul>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6" data-id="element-88">
              <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-89">
                <span className="text-2xl mr-3" style={{
                color: '#FA7315'
              }} data-id="element-90">
                  👉
                </span>
                <span className="font-semibold text-slate-900" data-id="element-91">
                  Eso no es falta de capacidad.
                </span>
              </div>
              <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-92">
                <span className="text-2xl mr-3" style={{
                color: '#FA7315'
              }} data-id="element-93">
                  👉
                </span>
                <span className="font-semibold text-slate-900" data-id="element-94">
                  Es falta de estructura.
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="bg-white p-10 rounded-2xl border border-slate-200 shadow-lg" data-id="element-95">
            <h3 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-96">
              Cuando no controlas tus fugas:
            </h3>
            <ul className="space-y-5 mb-10" data-id="element-97">
              {['Regalas tiempo sin retorno.', 'Tomas decisiones con fatiga mental.', 'Llegas tarde a oportunidades que otros sí aprovechan.', 'Sin notarlo, dejas clientes y mercado sobre la mesa.'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-slate-700 text-base md:text-lg" data-id="element-98">
                  <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0 mt-2" data-id="element-99" />
                  <span data-id="element-100">{item}</span>
                </li>)}
            </ul>

            <div className="text-center space-y-6 pt-6 border-t border-slate-100" data-id="element-101">
              <p className="text-lg md:text-xl font-medium text-slate-900" data-id="element-102">
                Ese es el techo invisible. Y no se rompe con más esfuerzo.
              </p>
              <p className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-103">
                No necesitas hacer más.
              </p>
              <p className="text-2xl md:text-3xl font-bold" style={{
              color: '#FA7315'
            }} data-id="element-104">
                Necesitas jugar en un nivel distinto.
              </p>
            </div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center space-y-8" data-id="element-105">
            <p className="text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-106">
              Los vendedores de alto rendimiento no ganan por trabajar más
              horas. Ganan porque saben exactamente dónde poner su tiempo,
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-107">
              <div className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm text-slate-900 font-bold" data-id="element-108">
                El resto:
              </div>
              <div className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm text-slate-600 font-medium" data-id="element-109">
                Lo eliminan.
              </div>
              <div className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm text-slate-600 font-medium" data-id="element-110">
                Lo delegan.
              </div>
              <div className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm text-slate-600 font-medium md:col-span-3" data-id="element-111">
                O simplemente dejan de jugarlo.
              </div>
            </div>
            <p className="text-xl md:text-2xl font-bold text-slate-900 pt-6" data-id="element-112">
              No necesitas hacer más. Solo ajustar tu nivel de juego.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 6. Modules Section */}
      <section className="px-6 py-24 bg-white" data-id="element-113">
        <div className="max-w-5xl mx-auto" data-id="element-114">
          <motion.div className="text-center mb-20" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-115">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-116">
              ¿Qué es Juega Desde Otro Nivel?
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-117">
              Un entrenamiento 90% práctico / 10% conceptual, donde sales con
              decisiones tomadas, no con notas bonitas.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-118">
            {[{
            icon: '1️⃣',
            title: 'Cuánto vale una hora de tu tiempo',
            desc: 'Si no sabes su valor, estás perdiendo dinero sin darte cuenta. El tiempo se mide como inversión. Si no da retorno → no va.'
          }, {
            icon: '2️⃣',
            title: 'La ley 80/20 aplicada de verdad',
            desc: 'No para "enfocarte en lo importante", sino para eliminar el 80% que no suma y te drena.'
          }, {
            icon: '3️⃣',
            title: 'Identificación de fugas invisibles',
            desc: 'Las tres que no se recuperan jamás: Tiempo, Energía, Foco. Aquí descubres dónde se están yendo tus resultados.'
          }, {
            icon: '4️⃣',
            title: 'Sistemas > Metas',
            desc: 'Cómo dejar de depender de fuerza de voluntad y crear estructuras que garanticen avance, incluso en semanas difíciles.'
          }].map((module, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1,
            duration: 0.5
          }} className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-orange-200 transition-all duration-300" data-id="element-119">
                <div className="text-5xl mb-5" data-id="element-120">{module.icon}</div>
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-121">
                  {module.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-122">{module.desc}</p>
              </motion.div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-123">
            <p className="text-xl md:text-2xl font-semibold text-slate-900" data-id="element-124">
              Esto es lo que pasa cuando hay claridad (no motivación)
            </p>
          </div>
        </div>
      </section>

      {/* 7. WhatsApp Testimonials */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-125">
        <div className="max-w-7xl mx-auto" data-id="element-126">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-127">
            <TestimonialCard quote="No me motivaron, me ordenaron. Y eso me quitó un peso mental que no sabía que cargaba." linkText="Ver conversación" linkUrl="#testimonio-1" imageUrl="https://cdn.magicpatterns.com/uploads/g2bfbmTWTUZShfswFwM4fV/Tettimonio_Roger.jpg" delay={0} data-id="element-128" />
            <TestimonialCard quote="No cambié mi vida. Cambié mi perspectiva y la forma como tomo decisiones. Y eso lo cambia todo." linkText="Ver conversación" linkUrl="#testimonio-2" imageUrl="https://cdn.magicpatterns.com/uploads/3HEAYqYadj34Rqm7difeG2/Rosaurita_Perdomo.jpg" delay={0.1} data-id="element-129" />
            <TestimonialCard quote="Pensé que sería algo básico por el precio. Me llevó una forma completamente distinta de organizar mi tiempo y liderar." linkText="Ver conversación" linkUrl="#testimonio-3" imageUrl="https://cdn.magicpatterns.com/uploads/pWP23F7JNsyeDTGyK86cf4/Diana_moreno.jpg" delay={0.2} data-id="element-130" />
            <TestimonialCard quote="Cada hora debe tener retorno. Ya no regalo mi tiempo." linkText="Ver conversación" linkUrl="#testimonio-4" imageUrl="https://cdn.magicpatterns.com/uploads/mYXcFxWBJHgK5ScwyhLMJF/Testimonio_Wh_Maria_Consuelo_Restrepo_Entrenamiento.jpg" delay={0.3} data-id="element-131" />
          </div>
        </div>
      </section>

      {/* 8. Video Testimonials */}
      <section className="px-6 py-24 bg-white" style={{
      padding: '80px 0px'
    }} data-id="element-132">
        <div className="max-w-7xl mx-auto" data-id="element-133">
          <div className="text-center mb-16" data-id="element-134">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-135">
              Resultados reales, enfoques distintos
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-136">
            {[{
            id: 'zadn492ltd',
            aspect: '0.5164992826398852'
          }, {
            id: 'n6ngvv6hee',
            aspect: '0.5625'
          }, {
            id: 'psa74yg6wr',
            aspect: '0.5625'
          }, {
            id: '4d7zhpdcnk',
            aspect: '0.5769230769230769'
          }, {
            id: '9yq00dgg3u',
            aspect: '0.5625'
          }].map((video, idx) => <motion.div key={video.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1,
            duration: 0.5
          }} className="rounded-xl overflow-hidden shadow-lg" data-id="element-137">
                <wistia-player media-id={video.id} aspect={video.aspect} data-id="element-138"></wistia-player>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 9. Target Audience */}
      <section className="px-6 py-20 bg-slate-50" data-id="element-139">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-141">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-142">
              <Check className="text-green-500 w-7 h-7" data-id="element-143" /> Es para ti si:
            </h3>
            <ul className="space-y-5 text-slate-700 text-base md:text-lg" data-id="element-144">
              {['Vendes, pero sientes desgaste.', 'Quieres cerrar más sin trabajar más.', 'Sientes desgaste.', 'Quieres un foco real.'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-145">
                  <span className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0 mt-2" data-id="element-146" />
                  <span data-id="element-147">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-148">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3" data-id="element-149">
              <AlertTriangle className="text-red-500 w-7 h-7" data-id="element-150" /> No es para ti
              si:
            </h3>
            <ul className="space-y-5 text-slate-700 text-base md:text-lg" data-id="element-151">
              {['Buscas motivación.', 'Crees que vender es sólo trabajar más.', 'No quieres eliminar actividades.', 'Prefieres seguir ocupado.'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-152">
                  <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0 mt-2" data-id="element-153" />
                  <span data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </section>

      {/* 10. Event Details */}
      <section className="px-6 py-20 bg-white" data-id="element-155">
        <div className="max-w-4xl mx-auto" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border border-slate-200 shadow-xl" data-id="element-157">
            <div className="flex items-center gap-3 mb-8" style={{
            color: '#FA7315'
          }} data-id="element-158">
              <Clock className="w-6 h-6 animate-pulse" data-id="element-159" />
              <span className="font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-160">
                DETALLES (CON URGENCIA REAL)
              </span>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-slate-900" data-id="element-161">
              <div className="flex items-center gap-4" data-id="element-162">
                <Calendar className="text-slate-600 w-6 h-6" data-id="element-163" />
                <span data-id="element-164">Sábado 28 de febrero de 2026</span>
              </div>
              <div className="flex flex-col gap-2" data-id="element-165">
                <div className="flex items-center gap-4" data-id="element-166">
                  <Clock className="text-slate-600 w-6 h-6" data-id="element-167" />
                  <span data-id="element-168">8:00 am México</span>
                </div>
                <div className="flex items-center gap-4" data-id="element-169">
                  <div className="w-6 h-6" data-id="element-170" />
                  <span className="text-slate-600" data-id="element-171">
                    9:00 am Miami / Colombia, Perú, Ecuador
                  </span>
                </div>
                <div className="flex items-center gap-4" data-id="element-172">
                  <div className="w-6 h-6" data-id="element-173" />
                  <span className="text-slate-600" data-id="element-174">10:00 am Venezuela</span>
                </div>
                <div className="flex items-center gap-4" data-id="element-175">
                  <div className="w-6 h-6" data-id="element-176" />
                  <span className="text-slate-600" data-id="element-177">11:00 am Argentina</span>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-178">
                <MapPin className="text-slate-600 w-6 h-6" data-id="element-179" />
                <span data-id="element-180">Por Zoom – en vivo</span>
              </div>

              <div className="mt-10 p-6 bg-orange-50 border-2 border-orange-200 rounded-xl" data-id="element-181">
                <p className="font-bold text-orange-900 leading-relaxed" data-id="element-182">
                  👉 Bono por asistir en vivo: Plantilla del Sistema Mínimo
                  Semanal + 3 indicadores clave (solo para asistentes en tiempo
                  real)
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 11. Final CTA */}
      <section id="final-cta" className="px-6 py-28 bg-gradient-to-b from-white to-slate-50 text-center" data-id="element-183">
        <div className="max-w-4xl mx-auto" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-10" data-id="element-185">
            <div className="space-y-6 text-xl md:text-2xl text-slate-700" data-id="element-186">
              <p data-id="element-187">Si sigues usando mal tu tiempo,</p>
              <p className="font-bold text-slate-900 text-2xl md:text-3xl" data-id="element-188">
                Estás vendiendo por debajo de tu nivel.
              </p>
              <p className="pt-4" data-id="element-189">
                El próximo mes no será distinto si no ajustas cómo estás jugando
                hoy.
              </p>
            </div>

            <div className="pt-6" data-id="element-190">
              <CTAButton text="QUIERO AJUSTAR MI NIVEL DE JUEGO" subtitle="90 minutos. Claridad total. Decisiones tomadas." href="https://coneckta.co/taller-juegadesdeotronivel" fullWidth={true} className="md:w-auto md:px-16 text-lg md:text-xl" data-id="element-191" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* 12. Footer */}
      <footer className="px-6 py-16 bg-slate-900 text-center" data-id="element-192">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-193">
          <div data-id="element-194">
            <h4 className="text-2xl font-bold text-white mb-3" data-id="element-195">
              Juega Desde Otro Nivel
            </h4>
            <p className="text-slate-400 text-lg" data-id="element-196">
              Vende mejor, con menos desgaste.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm md:text-base" data-id="element-197">
            <button onClick={() => setShowPrivacyModal(true)} className="text-slate-300 hover:text-white transition-colors underline underline-offset-4 decoration-slate-500 hover:decoration-white" data-id="element-198">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTermsModal(true)} className="text-slate-300 hover:text-white transition-colors underline underline-offset-4 decoration-slate-500 hover:decoration-white" data-id="element-199">
              Términos y Condiciones
            </button>
          </div>

          <div className="pt-6 border-t border-slate-800" data-id="element-200">
            <p className="text-slate-400 text-sm md:text-base" data-id="element-201">
              © {new Date().getFullYear()} Juega Desde Otro Nivel. Todos los
              derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-202">
        {showPrivacyModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowPrivacyModal(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 overflow-y-auto" data-id="element-203">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} onClick={e => e.stopPropagation()} className="relative max-w-3xl w-full bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-204">
              <div className="sticky top-0 bg-white border-b border-slate-200 p-6 flex items-center justify-between rounded-t-2xl z-10" data-id="element-205">
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-206">
                  Política de Privacidad
                </h2>
                <button onClick={() => setShowPrivacyModal(false)} className="flex items-center justify-center w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors" data-id="element-207">
                  <X size={20} data-id="element-208" />
                </button>
              </div>

              <div className="p-8 space-y-8 text-slate-700" data-id="element-209">
                <section data-id="element-210">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-211">
                    1. Información que Recopilamos
                  </h3>
                  <p className="leading-relaxed" data-id="element-212">
                    Recopilamos información personal que usted nos proporciona
                    directamente al registrarse en nuestro entrenamiento,
                    incluyendo nombre, correo electrónico, número de teléfono y
                    otra información de contacto necesaria para brindarle
                    nuestros servicios.
                  </p>
                </section>

                <section data-id="element-213">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-214">
                    2. Uso de la Información
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-215">
                    Utilizamos su información personal para:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-216">
                    <li data-id="element-217">Procesar su registro al entrenamiento</li>
                    <li data-id="element-218">
                      Enviarle información sobre el evento y materiales
                      relacionados
                    </li>
                    <li data-id="element-219">
                      Comunicarnos con usted sobre actualizaciones y ofertas
                      futuras
                    </li>
                    <li data-id="element-220">
                      Mejorar nuestros servicios y experiencia del usuario
                    </li>
                  </ul>
                </section>

                <section data-id="element-221">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-222">
                    3. Protección de Datos
                  </h3>
                  <p className="leading-relaxed" data-id="element-223">
                    Implementamos medidas de seguridad técnicas y organizativas
                    apropiadas para proteger su información personal contra
                    acceso no autorizado, alteración, divulgación o destrucción.
                  </p>
                </section>

                <section data-id="element-224">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-225">
                    4. Compartir Información
                  </h3>
                  <p className="leading-relaxed" data-id="element-226">
                    No vendemos, alquilamos ni compartimos su información
                    personal con terceros, excepto cuando sea necesario para
                    proporcionar nuestros servicios o cuando la ley lo requiera.
                  </p>
                </section>

                <section data-id="element-227">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-228">
                    5. Sus Derechos
                  </h3>
                  <p className="leading-relaxed" data-id="element-229">
                    Usted tiene derecho a acceder, corregir o eliminar su
                    información personal en cualquier momento. Para ejercer
                    estos derechos, contáctenos a través de nuestros canales de
                    comunicación.
                  </p>
                </section>

                <section data-id="element-230">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-231">
                    6. Cookies
                  </h3>
                  <p className="leading-relaxed" data-id="element-232">
                    Utilizamos cookies y tecnologías similares para mejorar su
                    experiencia en nuestro sitio web, analizar el tráfico y
                    personalizar el contenido.
                  </p>
                </section>

                <section data-id="element-233">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-234">
                    7. Contacto
                  </h3>
                  <p className="leading-relaxed" data-id="element-235">
                    Si tiene preguntas sobre esta Política de Privacidad, puede
                    contactarnos a través de los canales de comunicación
                    proporcionados en nuestro sitio web.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Terms and Conditions Modal */}
      <AnimatePresence data-id="element-236">
        {showTermsModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowTermsModal(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 overflow-y-auto" data-id="element-237">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} onClick={e => e.stopPropagation()} className="relative max-w-3xl w-full bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-238">
              <div className="sticky top-0 bg-white border-b border-slate-200 p-6 flex items-center justify-between rounded-t-2xl z-10" data-id="element-239">
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-240">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTermsModal(false)} className="flex items-center justify-center w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors" data-id="element-241">
                  <X size={20} data-id="element-242" />
                </button>
              </div>

              <div className="p-8 space-y-8 text-slate-700" data-id="element-243">
                <section data-id="element-244">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-245">
                    1. Aceptación de Términos
                  </h3>
                  <p className="leading-relaxed" data-id="element-246">
                    Al registrarse en el entrenamiento "Juega Desde Otro Nivel",
                    usted acepta estar sujeto a estos Términos y Condiciones. Si
                    no está de acuerdo con alguna parte de estos términos, no
                    debe registrarse en el evento.
                  </p>
                </section>

                <section data-id="element-247">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-248">
                    2. Descripción del Servicio
                  </h3>
                  <p className="leading-relaxed" data-id="element-249">
                    "Juega Desde Otro Nivel" es un entrenamiento en vivo de 90
                    minutos diseñado para vendedores y líderes que buscan
                    optimizar su tiempo, energía y foco para mejorar sus
                    resultados de ventas.
                  </p>
                </section>

                <section data-id="element-250">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-251">
                    3. Registro y Pago
                  </h3>
                  <ul className="list-disc list-inside space-y-3 ml-4" data-id="element-252">
                    <li data-id="element-253">
                      El registro se completa mediante el pago del monto
                      especificado
                    </li>
                    <li data-id="element-254">
                      Los pagos son procesados de forma segura a través de
                      plataformas de terceros
                    </li>
                    <li data-id="element-255">
                      Una vez completado el pago, recibirá un correo de
                      confirmación con los detalles de acceso
                    </li>
                  </ul>
                </section>

                <section data-id="element-256">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-257">
                    4. Política de Reembolsos
                  </h3>
                  <p className="leading-relaxed" data-id="element-258">
                    Los reembolsos se procesarán únicamente si se solicitan con
                    al menos 24 horas de anticipación al inicio del
                    entrenamiento. No se realizarán reembolsos después de
                    iniciado el evento.
                  </p>
                </section>

                <section data-id="element-259">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-260">
                    5. Propiedad Intelectual
                  </h3>
                  <p className="leading-relaxed" data-id="element-261">
                    Todo el contenido, materiales y recursos proporcionados
                    durante el entrenamiento son propiedad exclusiva de "Juega
                    Desde Otro Nivel" y están protegidos por leyes de propiedad
                    intelectual. Queda prohibida su reproducción, distribución o
                    uso comercial sin autorización expresa.
                  </p>
                </section>

                <section data-id="element-262">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-263">
                    6. Conducta del Participante
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-264">
                    Los participantes se comprometen a:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-265">
                    <li data-id="element-266">
                      Mantener un comportamiento respetuoso durante el
                      entrenamiento
                    </li>
                    <li data-id="element-267">
                      No grabar, capturar o distribuir el contenido sin
                      autorización
                    </li>
                    <li data-id="element-268">
                      Participar activamente y aprovechar al máximo la
                      experiencia
                    </li>
                  </ul>
                </section>

                <section data-id="element-269">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-270">
                    7. Limitación de Responsabilidad
                  </h3>
                  <p className="leading-relaxed" data-id="element-271">
                    El entrenamiento se proporciona "tal cual" y no garantizamos
                    resultados específicos. Los resultados dependen de la
                    implementación individual de las estrategias compartidas.
                  </p>
                </section>

                <section data-id="element-272">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-273">
                    8. Modificaciones
                  </h3>
                  <p className="leading-relaxed" data-id="element-274">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Los cambios entrarán en vigor
                    inmediatamente después de su publicación.
                  </p>
                </section>

                <section data-id="element-275">
                  <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-276">
                    9. Contacto
                  </h3>
                  <p className="leading-relaxed" data-id="element-277">
                    Para cualquier pregunta sobre estos Términos y Condiciones,
                    puede contactarnos a través de los canales de comunicación
                    proporcionados en nuestro sitio web.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}